import userClient from '../config/api/userClient';
var getLabelSimpleUrl = "label/simple";
var getLabelsUrl = "label";
export var getLabelSimple = function (params) {
    return userClient.get(getLabelSimpleUrl, { params: params });
};
export var getLabels = function (params) {
    return userClient.get(getLabelsUrl, { params: params });
};
